/**
 * Shared Business Zod Validation Schemas
 * Used by both frontend and backend for consistency.
 */
import * as z from 'zod';

import { DATA_LOCALIZATION_REGION_REGEX } from '../enums/dataLocalizationRegion';

export const pauseMarketingTemplatesSchema = z.object({
  pauseMarketingTemplates: z.boolean(),
});

export type PauseMarketingTemplatesType = z.infer<
  typeof pauseMarketingTemplatesSchema
>;

export const dataLocalizationRegionSchema = z.object({
  dataLocalizationRegion: z
    .string()
    .regex(
      DATA_LOCALIZATION_REGION_REGEX,
      'Must be a 2-letter uppercase ISO country code',
    )
    .nullable(),
});

export type DataLocalizationRegionType = z.infer<
  typeof dataLocalizationRegionSchema
>;

/**
 * Origin allowlist for the embeddable web widget. Each entry is either an
 * exact origin (`https://giva.in`) or a wildcard subdomain pattern
 * (`https://*.giva.in`). The backend's `matchOrigin` enforces the same
 * shape — keep this schema and that matcher in sync.
 */
export const WEB_WIDGET_ORIGIN_REGEX =
  /^https?:\/\/(\*\.)?[A-Za-z0-9.-]+(:[0-9]+)?\/?$/;

export const webWidgetOriginsSchema = z.object({
  origins: z
    .array(
      z
        .string()
        .min(1)
        .max(255)
        .regex(
          WEB_WIDGET_ORIGIN_REGEX,
          'Each origin must look like https://yoursite.com or https://*.yoursite.com',
        ),
    )
    .max(50, 'Limit 50 origins per business'),
});

export type WebWidgetOriginsType = z.infer<typeof webWidgetOriginsSchema>;
